export default "__VITE_ASSET__ee198e37__"